import * as React from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/utils/cn';

const labelVariants = cva(
  'font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 peer-data-disabled:cursor-not-allowed peer-data-disabled:opacity-70',
);

const Label = React.forwardRef<
  HTMLLabelElement,
  React.ComponentPropsWithoutRef<'label'> & VariantProps<typeof labelVariants>
>(({ className, htmlFor, children, ...props }, ref) => (
  <label className={cn(labelVariants(), className)} htmlFor={htmlFor} ref={ref} {...props}>
    {children}
  </label>
));
Label.displayName = 'Label';

export { Label };
